// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M16 12.6667V18L19.3334 20M16 6.66667C9.74079 6.66667 4.66669 11.7408 4.66669 18C4.66669 24.2592 9.74079 29.3333 16 29.3333C22.2592 29.3333 27.3334 24.2592 27.3334 18C27.3334 11.7408 22.2592 6.66667 16 6.66667ZM16 6.66667V2.66667M13.3334 2.66667H18.6667M27.1053 7.45606L25.1053 5.45606L26.1053 6.45606M4.89471 7.45606L6.89471 5.45606L5.89471 6.45606"
    />
  </svg>
);
const IconClockStopwatch = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconClockStopwatch;
